export const tr = {
    'high-priority': 'Yüksek',
    'low-priority': 'Düşük',
    'medium-priority': 'Orta',
    'replace-validation-error-invalid-characters':
        'Negatif anahtar sözcükler boşlukla ayrılarak, "-" ve "," işaretleri kullanılmadan yazılmalıdır.',
    'status-active': 'Aktif',
    'status-archived': 'Arşivde',
    'status-draft': 'Taslak',
    'status-reject-by-moderator': 'Sözcük grubu moderasyonda reddedildi',
    'status-stopped': 'Durduruldu'
};
